export default ($axios) => ({
  fetch(query) {
    return $axios.get('/sms/campaigns', { params: query }).then((response) => response.data);
  },
});
